import { truncateDecimals } from '@lair-finance/util'
import { displayAmount } from '@/shared/lib/utils/format.ts'

export function formatAssetAmount(amount: string) {
  return displayAmount(truncateDecimals(amount, 4, true), { threshold: '0.0001' })
}
